import { Image } from '@chakra-ui/react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Box } from '@/components/ui/box'
import { Button } from '@/components/ui/button'
import { Text } from '@/components/ui/typography'
import useCustomToast from '@/hooks/toasts'
import useCustomMediaQuery from '@/hooks/useCustomMediaQuery'
import { queryClient } from '@/QueryClient'
import { getCompliances } from '@/store/tasksApprovals'
import { bulkApprovals } from '@/store/tasksApprovals/detailsDrawer'

const Container = ({ itemId, onClose }: { itemId: string; onClose: () => void }) => {
    const { t } = useTranslation()
    const [addToast] = useCustomToast()

    const [isApproveSet, setIsApproveSet] = useState<boolean>(false)
    const [isRejectSet, setIsRejectSet] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [isMobile] = useCustomMediaQuery()

    const onApprove = () => {
        setIsApproveSet(true)
    }
    const onReject = () => {
        setIsRejectSet(true)
    }

    const onConfirm = (action: 'approve' | 'reject') => {
        setIsLoading(true)
        void bulkApprovals(
            'SAIL_POINT_CERT_DECISION',
            [
                {
                    itemId,
                    approve: action === 'approve',
                    rejectionReason: '',
                },
            ],
            'compliances',
            false,
        ).then((res) => {
            if (res && res.ok) {
                void queryClient.invalidateQueries({ queryKey: ['compliances'] })
                void getCompliances(true)
                action === 'approve'
                    ? addToast('success', t('tasksApprovals.drawer.approvalSuccessful'))
                    : addToast('success', t('tasksApprovals.drawer.rejectionSuccessful'))
            }
            onClose()
            setIsLoading(false)
        })
    }

    const onCancel = () => {
        if (isApproveSet || isRejectSet) {
            setIsApproveSet(false)
            setIsRejectSet(false)
        } else {
            onClose()
        }
    }

    return (
        <>
            <Box pb="24px">
                <Text fontSize="14px">{t('tasksApprovals.sailPointCertDecisionDrawer.footer.text_1')}</Text>
                <Text fontSize="14px">{t('tasksApprovals.sailPointCertDecisionDrawer.footer.text_2')}</Text>
                <Box display="flex" alignItems="center" mt="8px">
                    <Image src="/assets/alert_icon.svg" maxW="14px" />
                    <Text fontSize="14px" pl="8px">
                        {t('tasksApprovals.sailPointCertDecisionDrawer.footer.text_3')}
                    </Text>
                </Box>
            </Box>
            <Button variant="secondary" mr="16px" onClick={onCancel}>
                {isApproveSet || isRejectSet ? t('tasksApprovals.drawer.buttons.cancel') : t('tasksApprovals.drawer.buttons.close')}
            </Button>
            {!isApproveSet && !isRejectSet && (
                <>
                    <Button
                        variant="reject"
                        onClick={onReject}
                        mr="16px"
                        fontSize="12px"
                        letterSpacing="1.5px"
                        textTransform="uppercase"
                        fontWeight="bold"
                    >
                        {isMobile
                            ? t('tasksApprovals.drawer.buttons.requestRevocationMobile')
                            : t('tasksApprovals.drawer.buttons.requestRevocation')}
                    </Button>

                    <Button
                        variant="primary"
                        onClick={onApprove}
                        mr="16px"
                        letterSpacing="1.5px"
                        textTransform="uppercase"
                        fontWeight="bold"
                    >
                        {isMobile
                            ? t('tasksApprovals.drawer.buttons.requestApprovalMobile')
                            : t('tasksApprovals.drawer.buttons.requestApproval')}
                    </Button>
                </>
            )}
            {isApproveSet && !isLoading && (
                <Button variant="primary" onClick={() => onConfirm('approve')} textTransform="uppercase" letterSpacing="1.5px">
                    {t('tasksApprovals.drawer.buttons.confirmApproval')}
                </Button>
            )}
            {isRejectSet && !isLoading && (
                <Button variant="primary" onClick={() => onConfirm('reject')} textTransform="uppercase" letterSpacing="1.5px">
                    {t('tasksApprovals.drawer.buttons.confirmRevocation')}
                </Button>
            )}
        </>
    )
}

export default Container
